export const RCS_STATUS_SUBMITTED = 1
export const RCS_STATUS_IN_REVIEW = 2
export const RCS_STATUS_REJECTED = 3
export const RCS_STATUS_APPROVED = 4
